import { render, staticRenderFns } from "./OrderListOnDeliveryPage.vue?vue&type=template&id=50fc6158&scoped=true&"
import script from "./OrderListOnDeliveryPage.vue?vue&type=script&lang=js&"
export * from "./OrderListOnDeliveryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fc6158",
  null
  
)

export default component.exports